import {Message} from 'element-ui'

export function returnValue (key, val) {
  let values = ''
  if (val) {
    val.forEach(item => {
      if (item.searchValue === key) {
        values = item.value
      }
    })
  }
  return values
}

// 后端上传接口允许的格式白名单与大小限制（与 /v1/fileUpload/upload 规则一致）
const UPLOAD_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'webp', 'mp4', 'mp3']
const UPLOAD_MAX_SIZE_MB = 50

// 校验待上传文件，不合法时弹出提示并返回 false
export function checkUploadFile(file) {
  const extension = (file.name.split('.').pop() || '').toLowerCase()
  if (UPLOAD_ALLOWED_EXTENSIONS.indexOf(extension) === -1) {
    Message.error(`仅支持上传 ${UPLOAD_ALLOWED_EXTENSIONS.join(' / ')} 格式的文件`)
    return false
  }
  if (file.size / 1024 / 1024 > UPLOAD_MAX_SIZE_MB) {
    Message.error(`文件大小不能超过 ${UPLOAD_MAX_SIZE_MB}MB`)
    return false
  }
  return true
}